import React from "react"
import * as geojson from 'geojson';
import { GeoJSON } from "react-leaflet";

export interface IGeoJsonLineWithHaloProps {    
    data: geojson.GeoJsonObject,
    color: string,
    haloColor: string,
    weight: number,
    onEachFeature?: (feature: geojson.Feature<geojson.Geometry, any>, layer: L.Layer) => void
}

export function GeoJsonLineWithHalo(props: IGeoJsonLineWithHaloProps) {
    return (
        <>
            <GeoJSON data={props.data} style={{color: props.haloColor, weight: props.weight+2}} onEachFeature={props.onEachFeature}/>
            <GeoJSON data={props.data} style={{color: props.color, weight: props.weight}} onEachFeature={props.onEachFeature}/>
        </>
    )
}